$('.button-loader').on('click', function () {
    $(this).toggleClass('loading');
});
